/**
 * Returns an attachment QUIZ object.
 * This object should be the first ELA quiz attachment or the first available QUIZ returned for the user
 * If no quizzes are passed into the array of attachmnents, it will return undefined
 * @param {array} attachments
 * @returns {object}
 */
const getDefaultQuizAttachment = (attachments) => {
  if (!attachments) return;

  const quizAttachments = attachments.filter((attachment) => {
    return attachment.data?.assessment_type === "QUIZ";
  });

  const elaQuiz = quizAttachments?.find((attachment) => {
    return attachment.data?.name?.includes("ELA");
  });

  return elaQuiz ?? quizAttachments?.[0];
};

export default getDefaultQuizAttachment;
